<template id="landingTmpl" >
	<v-app id="vappLanding" class="vappDefault">

		<ct-toolbar appname='apps'></ct-toolbar>

		<v-main>
			{{ /* v-container fluid */ }}
			<v-container>

			<ct-loading></ct-loading>
			<ct-dialog></ct-dialog>	

			<slot></slot>

			</v-container>
		</v-main>
		<ct-footer></ct-footer>
	</v-app>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
    props: ['backurl','breadcrumbs'],
}
</script>